import React from "react";
import point from "./../../../../Images/point.png";

const MicroBladingInMeadowsAfterCare = () => {
  return (
    <div className="hairSalonInMeadowsWhy">
      <h5>Aftercare Tips for Eyebrow Microblading in Meadows Whitefield</h5>
      <p>
        To maintain the longevity and appearance of your Eyebrow Microblading in
        Meadows Whitefield results, it's crucial to follow proper aftercare
        instructions. Here are a few essential tips:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Avoid Water:{" "}
          </span>
          <p>
            For the first 7-10 days after your Eyebrow Microblading in Meadows
            Whitefield session, avoid getting your brows wet. This includes
            avoiding activities like swimming, saunas, and heavy sweating.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            No Makeup:{" "}
          </span>
          <p>
            Refrain from applying makeup to the brow area while your skin is
            healing.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Moisturize:{" "}
          </span>
          <p>
            Keep the treated area moisturized with a recommended aftercare
            ointment to prevent dryness and flaking.
          </p>
        </li>{" "}
        <li>
          <span>
            <img src={point} alt="point" />
            Touch-Ups:{" "}
          </span>
          <p>
            A follow-up touch-up session may be needed 4-6 weeks after your
            initial appointment to perfect the look of your brows.
          </p>
        </li>{" "}
      </ul>
    </div>
  );
};

export default MicroBladingInMeadowsAfterCare;
